import React from 'react';
import { SpinnerV2 } from '../SpinnerV2';
import { matchAny } from './matchers';

const markIt = (name, query) => {
  const regexp = matchAny(query);
  return name.replace(regexp, '<mark>$&</mark>');
};

const DefaultSuggestionComponent = ({ item, query }) => {
  return <span dangerouslySetInnerHTML={{ __html: markIt(item.name, query) }} />;
};

const getOptionElement = (props, item, index, SuggestionComponent) => {
  const key = `${props.id}-${index}`;
  const classNames = [];

  if (props.index === index) {
    classNames.push(props.classNames.suggestionActive);
  }

  if (item.disabled) {
    classNames.push(props.classNames.suggestionDisabled);
  }

  return (
    <li
      id={key}
      key={key}
      role='option'
      aria-selected={true}
      className={classNames.join(' ')}
      aria-disabled={Boolean(item.disabled)}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => props.addTag(item)}
    >
      {item.prefix ? <span className={props.classNames.suggestionPrefix}>{item.prefix} </span> : null}
      {item.disableMarkIt ? item.name : <SuggestionComponent item={item} query={props.query} />}
    </li>
  );
};

const Suggestions = (props) => {
  const SuggestionComponent = props.suggestionComponent || DefaultSuggestionComponent;
  const optionsGroups = props.optionsGroups || [];
  const groupedOptions = { '': [] };
  if (optionsGroups) {
    for (let i = 0; i < optionsGroups.length; i++) {
      groupedOptions[optionsGroups[i].id] = [];
    }
  }

  for (let i = 0; i < props.options.length; i++) {
    const option = props.options[i];
    const optionElement = getOptionElement(props, option, i, SuggestionComponent);

    if (option.group && groupedOptions[option.group]) {
      groupedOptions[option.group].push(optionElement);
    } else {
      groupedOptions[''].push(optionElement);
    }
  }

  const addPreSelectedTag = (groupData) => {
    props.addTag({
      name: groupData.label,
      types: 'preSelectedTag',
      group: groupData.id,
      data: {
        address: '',
        circle: { radius: null },
        context: groupData.id,
        radius: null,
        types: null,
        urn: null,
      },
      icon: groupData.icon,
    });
  };

  const onClick = (e, groupData) => {
    if (props.initialScreen) {
      addPreSelectedTag(groupData);
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div className={props.classNames.suggestions}>
      {Object.keys(groupedOptions).map((group, index) => {
        const groupData = optionsGroups.filter((_group) => _group.id === group)[0];
        if (
          groupedOptions[group].length === 0 &&
          (!props?.isLoading || !props?.isLoading[groupData?.id]) &&
          !props.initialScreen
        ) {
          return null;
        }
        return (
          <div
            key={index}
            className={groupData?.id}
            onClick={(e) => {
              // we need it to prevent onFocus call in the ReactTags base component
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {group ? (
              <div
                className={`${props.classNames.groups} ${
                  props.isShowGroupDescription ? 'group-description' : 'no-group-description'
                }`}
                onClick={(e) => onClick(e, groupData)}
              >
                <div className={`${props.classNames.groups}__icon`}>{groupData.icon}</div>
                <div className='d-flex align-items-center justify-content-between w-100'>
                  <div className={`${props.classNames.groups}__text`}>
                    <div
                      className={`${props.classNames.groups}__label ${
                        props.isShowGroupDescription ? '' : `${props.classNames.groups}__label--with-border`
                      }`}
                    >
                      {groupData.label}
                      {props?.isLoading && props?.isLoading[groupData.id] && (
                        <div className='spinner'>
                          <SpinnerV2 relative inText />
                        </div>
                      )}
                    </div>
                    {props.isShowGroupDescription && (
                      <div className={`${props.classNames.groups}__description`}>{groupData.description}</div>
                    )}
                  </div>
                  {props.rightSuggestionsComponent && groupData.id === 'address' && props.rightSuggestionsComponent}
                </div>
              </div>
            ) : null}
            {group && index < Object.keys(groupedOptions).length - 1 ? <div className='divider'></div> : null}
            <ul role='listbox' className='group-suggestions' id={props.id + `--option-group${index}`}>
              {groupedOptions[group]}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default Suggestions;
